import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VisitorsEquipmentsService } from '../../services/visitors-equipments-services';
import { VisitorsVehiclesService } from '../../services/visitors-vehicles-services';
import { IVisitorEquipment } from '../../Interfaces/IVisitorsEquipments';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { IVisitorVehicle } from '../../Interfaces/IVisitorVehicle';
import { IMyApprovals } from '../../Interfaces/IMyApprovals';
import { PropertiesService } from '../../services/properties-services';
import { IProperties } from '../../Interfaces/IProperties';
import { UploadFileService } from '../../services/upload-file.service';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { MyApprovalsService } from '../../services/myApprovals-service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IRejectApprovals } from '../../Interfaces/IRejectApprovals';
import { RejectApprovalComponent } from '../reject-approval/reject-approval.component';
import { IDocumentsSuppliersVisits } from '../../Interfaces/IDocumentsSuppliersVisits';
import { VisitsService } from '../../services/visits-service'

interface MyApprovals {
  PKVisitByVisitors: number;
  fk_visitor_by_visit: number;
  fk_approver_area: number;
  fkApprover: number;
}

@Component({
  selector: 'my-approvals-details',
  templateUrl: './my-approvals-details.component.html',
})
export class MyApprovalsDetailsComponent implements OnInit {
  applicationpath: string;
  bucketS3Property: string;
  columnsEquipments: Array<any> = [
    'visitor',
    'type_equipment',
    'brand',
    'model',
    'serial_number',
    'mac_address',
    'mac_address2',
  ];
  columnsEquipments2: Array<any> = [
		'visitor',
		'type_equipment',
		'brand',
		'model',
		'serial_number',
		'havemacaddress',
		'macaddressinformation',
	];
  columnsVehicles: Array<any> = [
    'visitor',
    'brand',
    'model',
    'color',
    'license_plate',
  ];
  formGroup: FormGroup;
  hideButtonApprove: boolean = false;
  hideButtonReject: boolean = false;
  hideButtonRedirectSubcontrating: boolean = true;
  hideActivity: boolean = false;
  hideAreaProject: boolean = false;
  hideBadge: boolean = false;
  hideCompanySupplier: boolean = false;
  hideDescription: boolean = false;
  hideDocumentPanel: boolean = false;
  hideCriticalWork: boolean = false;
  hideEmergencyContact: boolean = false;
  hideEmergencyName: boolean = false;
  hideFlight: boolean = false;
  hideFoodRestrictions: boolean = false;
  hideHotel: boolean = false;
  hideOriginBuilding: boolean = false;
  hideOriginSite: boolean = false;
  hideRequisitionIDPO: boolean = false;
  hideStartToWork: boolean = false;
  hideSupplierIncomeType: boolean = false;
  hideTemporaryBadge: boolean = false;
  hideVisitorID: boolean = false;
  hideVisitorPhone: boolean = false;
  hideVisitorPhoto: boolean = false;
  hideVisitorPhotoID: boolean = false;
  hideVisitorSponsor: boolean = false;
  hideVisitorRecruiter: boolean = false;
  hideCustomerCatalog: boolean = true;
  hideWorkdayID: boolean = false;
  BUCKET: string = '';
	REGION: string = '';
	FOLDER: string = '';
  NAME: string = '';
  urlFile: string = '';
  listDataVehicle: Array<IVisitorVehicle> = [];
  listDocuments: Array<IDocumentsSuppliersVisits> =[];
  listDataEquipment: Array<IVisitorEquipment> = [];
  loading: boolean;
  station: string = 'TABLE';
  listRejectApprovals: Array<IRejectApprovals> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IMyApprovals,
		private datePipe: DatePipe,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<MyApprovalsDetailsComponent>,
    private formBuilder: FormBuilder,
    private propertyService: PropertiesService,
    private router: Router,
    private uploadFileService: UploadFileService,
    private visitorsEquipmentsService: VisitorsEquipmentsService,
    private visitorsVehiclesService: VisitorsVehiclesService,
    private myApprovalsService: MyApprovalsService,
    private notificationService: NotificationService,
    private translate: TranslateApplicationService,
    private visitsService: VisitsService
  ) {
    this.formGroup = this.formBuilder.group({
      chkCriticalWork: [this.data.critical_work],
      chkStartToWork: [this.data.startofwork],
      chkVisitorForeignVisit: [this.data.foreignvisit],
      pkVisit: [this.data.pkvisit],
      pkVisitor: [this.data.pkvisitor],
      txtActivity: [this.data.activity],
      txtAreaProject: [this.data.areaproject],
      txtBadge: [this.data.badge],
      txtBuildingToVisit: [this.data.buildingtovisit],
      txtCompanySupplier: [this.data.companysupplier],
      txtDescription: [this.data.description],
      txtEmergencyContact: [this.data.emergencycontactname],
      txtEmergencyNumber: [this.data.emergencycontactnumber],
      txtEndDateVisit: [this.data.strenddatevisit],
      txtFlight: [this.data.flight],
      txtFoodRestrictions: [this.data.foodrestriction],
      txtHotel: [this.data.hotelinformation],
      txtOriginBuilding: [this.data.originbuilding],
      txtOriginSite: [this.data.originsite],
      txtRecruiter: [this.data.sponsorname],
      txtRequisitionIDPO: [this.data.requisitionIDPO],
      txtSiteToVisit: [this.data.sitetovisit],
      txtSponsor: [this.data.sponsorname],
      txtStartDateVisit: [this.data.strstartdatevisit],
      txtSupplierIncomeType: [this.data.supplierincometype],
      txtVisitorEmail: [this.data.email],
      txtVisitorID: [this.data.visitorid],
      txtVisitorName: [this.data.visitorname],
      txtVisitorPhone: [this.data.phone],
      txtVisitorPhoto: [this.data.visitorphoto],
      txtVisitorPhotoID: [this.data.visitorphotoid],
      txtVisitEndHour: [this.data.endhour],
      txtVisitStartHour: [this.data.starthour],
      txtVisitType: [this.data.visittype],
      txtWorkdayID: [this.data.workday]
    });
  }

  ngOnInit(): void {
    this.formGroup.controls.txtAreaProject.value;
    if(this.formGroup.controls.txtVisitorPhotoID.value == ''){
      this.formGroup.controls.txtVisitorPhotoID.setValue('VisitorPhotos/defaultPhoto.png');
    }
    if(this.formGroup.controls.txtVisitorPhoto.value == ''){
      this.formGroup.controls.txtVisitorPhoto.setValue('VisitorPhotos/defaultPhoto.png');
    } 
    this.loading = true;
    this.HideFieldsByVisitType();
    this.GetApplicationPathProperty();
    this.GetAvailableEquipmentsByVisitor();
    this.GetDocuments();
    this.loading = false;
  }

  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

  Close() {
    this.dialogRef.close();
  }

  GetApplicationPathProperty() {
    this.propertyService
      .GetPropertyByName('BUCKET_APPLICATION_PATH')
      .subscribe(
        (result: TransactionResult<IProperties[]>) => {
          if (result.success) {
            this.applicationpath = result.data[0].propertyvalue;
            this.GetBucketS3Property();
          }
        }
      );
  }

  GetAvailableEquipmentsByVisitor() {
    this.visitorsEquipmentsService
      .GetAvailableEquipmentsByVisitor(this.formGroup.value)
      .subscribe(
        (result: TransactionResult<IVisitorEquipment[]>) => {
          if (result.success) {
            this.listDataEquipment = result.data;
            this.GetAvailableVehiclesByVisitor();
          }
			  }
      );
  }

  GetAvailableVehiclesByVisitor() {
    this.visitorsVehiclesService
      .GetAvailableVehiclesByVisitor(this.formGroup.value)
      .subscribe(
        (result: TransactionResult<IVisitorVehicle[]>) => {
          if (result.success) {
            this.listDataVehicle = result.data;
          }
			  }
      );
  }

  GetBucketS3Property() {
    this.propertyService
      .GetPropertyByName('S3_Bucket_GET_FILE_URL_API')
      .subscribe(
        (result: TransactionResult<IProperties[]>) => {
          if (result.success) {
            this.bucketS3Property = result.data[0].propertyvalue;
            this.GetImagePhotoID();
            this.GetImagePhoto();
          }
        }
      );
  }

  GetDocuments(){
    this.visitsService.GetDocuments(this.data.pkvisit).subscribe(
      (result: TransactionResult<IDocumentsSuppliersVisits[]>) => {
        if(result){
          this.listDocuments = result.data;
        }
      }
    );
  }

  downloadEvidence(document: string) {
    this.loading = true;
		this.propertyService
			.GetPropertyByName('BUCKET_APPLICATION_PATH')
			.subscribe(
				(result: TransactionResult<IProperties[]>) => {
					if (result.success) {
						this.FOLDER = result.data[0].propertyvalue;
						this.NAME = document;
						this.propertyService
							.GetPropertyByName(
								'S3_Bucket_GET_FILE_URL_API',
							)
							.subscribe(
								(
									apiURLResult: TransactionResult<
										IProperties[]
									>,
								) => {
									if (apiURLResult.success) {
										this.uploadFileService
											.GetFile(
												this.FOLDER,
												this.NAME,
												apiURLResult.data[0]
													.propertyvalue,
											)
											.subscribe(
												(
													result: TransactionResult<any>,
												) => {
													this.loading = false;
													if (result.success) {
														this.urlFile =
															result.data;
														const t = this;
														window.open(
															this.urlFile,
															'_blank',
														);
													}
												},
											);
									}
								},
								(error) => {
									this.loading = false;
									console.log(error);
								},
							);
					}
				},
				(error: any) => {
					console.log(error);
					this.loading = false;
				},
			);
	}



  GetImagePhotoID() {
    this.uploadFileService
      .GetFile(this.applicationpath, this.formGroup.controls.txtVisitorPhotoID.value, this.bucketS3Property)
      .subscribe(
        (result: TransactionResult<any>) => {
          if (result.success) {
            this.formGroup.controls.txtVisitorPhotoID.setValue(result.data);
          }
        }
      );
  }

  GetImagePhoto() {
    this.uploadFileService
      .GetFile(this.applicationpath, this.formGroup.controls.txtVisitorPhoto.value, this.bucketS3Property)
      .subscribe(
        (result: TransactionResult<any>) => {
          if (result.success) {
            this.formGroup.controls.txtVisitorPhoto.setValue(result.data);
          }
        }
      );
  }

  HideFieldsByVisitType() {
    switch (this.formGroup.controls.txtVisitType.value) {
      case 'Suppliers':
        this.hideRequisitionIDPO = true;
        this.hideVisitorRecruiter = true;
        this.hideOriginSite = true;
        this.hideOriginBuilding = true;
        this.hideWorkdayID = true;
        this.hideBadge = true;
        this.hideFlight = true;
        this.hideHotel = true;
        this.hideFoodRestrictions = true;
        this.hideEmergencyContact = true;
        this.hideEmergencyName = true;
        this.hideDocumentPanel = false;

        if (this.data.approverarea == "MRO") {
          this.hideButtonRedirectSubcontrating = false;
        }
        break;
      case 'Not-Jabil visitors':
        this.hideSupplierIncomeType = true;
        this.hideCompanySupplier = true;
        this.hideVisitorPhoto = true;
        //this.hideVisitorPhotoID = true;
        this.hideVisitorPhone = true;
        this.hideTemporaryBadge = true;
        this.hideStartToWork = true;
        this.hideCriticalWork = true;
        this.hideVisitorRecruiter = true;
        this.hideOriginSite = true;
        this.hideOriginBuilding = true;
        this.hideWorkdayID = true;
        this.hideBadge = true;
        this.hideFlight = true;
        this.hideHotel = true;
        this.hideFoodRestrictions = true;
        this.hideEmergencyContact = true;
        this.hideEmergencyName = true;
        this.hideDocumentPanel = true;
        break;
      case 'Recruitment':
        this.hideSupplierIncomeType = true;
        this.hideCompanySupplier = true;
        this.hideVisitorSponsor = true;
        this.hideVisitorPhoto = true;
        this.hideVisitorPhotoID = true;
        this.hideVisitorID = true;
        this.hideTemporaryBadge = true;
        this.hideStartToWork = true;
        this.hideCriticalWork = true;
        this.hideActivity = true;
        this.hideDescription = true;
        this.hideAreaProject = true;
        this.hideOriginSite = true;
        this.hideOriginBuilding = true;
        this.hideWorkdayID = true;
        this.hideBadge = true;
        this.hideFlight = true;
        this.hideHotel = true;
        this.hideFoodRestrictions = true;
        this.hideEmergencyContact = true;
        this.hideEmergencyName = true;
        this.hideDocumentPanel = true;
        this.hideRequisitionIDPO = true;
        break;
      case 'Jabil visitors':
        this.hideSupplierIncomeType = true;
        this.hideCompanySupplier = true;
        this.hideVisitorPhoto = true;
        //this.hideVisitorPhotoID = true;
        this.hideStartToWork = true;
        this.hideCriticalWork = true;
        this.hideDocumentPanel = true;
        this.hideVisitorRecruiter = true;
        this.hideVisitorPhone = true;
        this.hideRequisitionIDPO = true;
        break;
      case 'Customers':
        this.hideCustomerCatalog = false;
        this.hideSupplierIncomeType = true;
        this.hideCompanySupplier = true;
        //this.hideVisitorPhoto = true;
        this.hideVisitorPhotoID = true;
        this.hideVisitorID = true;
        this.hideTemporaryBadge = true;
        this.hideStartToWork = true;
        this.hideCriticalWork = true;
        this.hideDocumentPanel = true;
        this.hideOriginSite = true;
        this.hideOriginBuilding = true;
        this.hideVisitorRecruiter = true;
        this.hideBadge = true;
        this.hideRequisitionIDPO = true;
        this.hideWorkdayID = true;
        break;
    }
  }

  Approve() {
    this.loading = true;

    this.myApprovalsService
      .ApproveVisitByVisitor([], this.data.fk_visitor_by_visit, this.data.fk_approver_area, this.data.fkApprover)
      .subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result.success) {
            this.Alert("Success", "Complete");
            this.Close();
          }
        },
        (error: any) => { this.ErrorAlert(error); this.loading = false; }
      );
  }

  Reject() {
    this.loading = true;

    let Visitor: IRejectApprovals = {
      listPKVisitByVisitors: this.data.pkvisitbyvisitor,
      fk_visitor_by_visit: this.data.fk_visitor_by_visit,
      fk_approver_area: this.data.fk_approver_area,
      fkApprover: this.data.fkApprover
    }

    this.listRejectApprovals.push(Visitor);

    const dialogRef = this.dialog.open(RejectApprovalComponent, {
      data: this.listRejectApprovals
    });
    dialogRef.afterClosed().subscribe((result) => { this.Close(); });

    /*this.myApprovalsService
      .RejectVisitByVisitor(this.data.fk_visitor_by_visit, this.data.fk_approver_area, this.data.fkApprover, "")
      .subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result.success) {
            this.Alert("Success", "Complete");
            this.Close();
          }
        },
        (error: any) => { this.ErrorAlert(error); this.loading = false; }
      );*/
  }

  RedirectToSubscontrating() {
    this.loading = true;

    this.myApprovalsService
      .RedirectToSubcontracting(this.data.fk_visitor_by_visit)
      .subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result.success) {
            this.Alert("Success", "Complete");
            this.Close();
          }
        },
        (error: any) => { this.ErrorAlert(error); this.loading = false; }
      );
  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }

}
